import { HAObject } from "../../Core/HAObject";
import { HorApp } from "../../Core/Service/HorApp";

export function init(func: unknown): void {
    new O1XWebPage({ jsNotification: func });
}

class O1XWebPage extends HAObject {
    protected initialize(data: any) {
        super.initialize(data);
        this.addToData("horApp", new HorApp(data));
    }

    private preventUnload() {
        window.addEventListener("beforeunload", (event: BeforeUnloadEvent) => {
            // Cancel the event as stated by the standard.
            event.preventDefault();
            // Older browsers supported custom message
            event.returnValue = "";
        });
    }
}
